// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"d3f9cc0f","453":"c57bc78e"}[chunkId] + ".chunk.js";
};